import { render } from "./NotificationPopup.vue?vue&type=template&id=786e5958&scoped=true"
import script from "./NotificationPopup.vue?vue&type=script&lang=js"
export * from "./NotificationPopup.vue?vue&type=script&lang=js"

import "./NotificationPopup.vue?vue&type=style&index=0&id=786e5958&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-786e5958"]])

export default __exports__